import React from 'react'
import Layout from '../components/common/layout'
import PrivacyPolicyComp from '../components/privacy-policy'
import SEO from '../components/common/seo'

const PrivacyPolicyPage = () => (
  <Layout>
    <SEO title="San Diego Refrigeration &amp; A/C Repair" />
    <PrivacyPolicyComp />
  </Layout>
)

export default PrivacyPolicyPage
